import React from 'react';
import PropTypes from 'prop-types';

import TermsAndConditionsModal from 'components/TermsAndConditionsModal/TermsAndConditionsModal';
import { useTnCGate } from 'hooks/useTnCGate';

const TnCGate = ({ isAuth, user, children }) => {
  const { termsTncVisible, handleAccept, acceptError, isAccepting, clearAcceptError } = useTnCGate(isAuth, user);

  return (
    <>
      <TermsAndConditionsModal
        visible={termsTncVisible}
        onAgree={handleAccept}
        acceptError={acceptError}
        isAccepting={isAccepting}
        onClearAcceptError={clearAcceptError}
      />
      {children}
    </>
  );
};

TnCGate.propTypes = {
  isAuth: PropTypes.bool,
  user: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  children: PropTypes.node
};

TnCGate.defaultProps = {
  isAuth: false,
  user: '',
  children: null
};

export default TnCGate;
